export default __webpack_public_path__ + "static/media/exchange icon.15980b12.svg";